export default "__VITE_ASSET__bcfb555b__"